import React from 'react';
import IndividualStandardMessageRow from './IndividualStandardMessageRow';
import SystemMessageCard from './SystemMessageCard';

export const ChatAnnouncementAvatar = ({
  className = 'chat-avatar message-avatar chat-avatar-announce announce-avatar',
  toneClassName = 'announce-tone--info',
  iconClass = 'fa-bullhorn',
  title = 'お知らせ',
}) => (
  <div className={`${className} ${toneClassName}`} title={title} aria-hidden="true">
    <i className={`fa-solid ${iconClass}`} aria-hidden="true" />
  </div>
);

const ChatGuidanceAnnouncementAvatar = ({
  className = 'chat-avatar message-avatar chat-avatar-announce announce-avatar',
}) => (
  <ChatAnnouncementAvatar
    className={className}
    toneClassName="announce-tone--intro"
    iconClass="fa-comments"
    title="案内"
  />
);

const GuidanceCard = ({ title, children }) => (
  <SystemMessageCard
    title={title}
    showIcon={false}
    iconClass="fa-comments"
    className="system-message-card--intro"
  >
    {children}
  </SystemMessageCard>
);

const ChatIntroGuidanceMessage = ({
  messageId,
  title,
  children,
}) => (
  <IndividualStandardMessageRow
    message={{ id: messageId }}
    preset="chatIntro"
    isSelf={false}
    showSender={false}
    bubbleClassName="system-message"
    avatarNode={<ChatGuidanceAnnouncementAvatar />}
    renderMessageContent={() => (
      <GuidanceCard title={title}>
        {children}
      </GuidanceCard>
    )}
  />
);

export const ArtistTacticartChatGuidanceMessage = () => (
  <ChatIntroGuidanceMessage
    messageId="artist-tacticart-chat-guidance"
    title="タクティカートとのチャットは"
  >
        <div className="system-message-card__text">
          あなたとタクティカートスタッフの専用チャットです。スタッフ個人とのチャットはできない仕様となっています。やり取りしたいスタッフがいる場合は＠メンション機能でスタッフ名を入力して候補を検索して指定することが可能です。
        </div>
  </ChatIntroGuidanceMessage>
);

export const ArtistEventChatGuidanceMessage = () => (
  <ChatIntroGuidanceMessage
    messageId="artist-event-chat-guidance"
    title="イベントチャットについて"
  >
      <div className="system-message-card__text">
        このチャットは、イベントに参加するアーティストとタクティカートの関係スタッフが、出演に必要な連絡を行う場所です。
      </div>
      <div className="system-message-card__text">
        スケジュール、持ち物、当日の動き、共有事項を確認できます。@で参加者やスタッフを検索してメンションできます。
      </div>
      <div className="system-message-card__text">
        画像・ファイル送信、返信、リアクション、ノート、お知らせ、参加者確認が使えます。
      </div>
  </ChatIntroGuidanceMessage>
);

export const AdminArtistChatGuidanceMessage = () => (
  <ChatIntroGuidanceMessage
    messageId="admin-artist-chat-guidance"
    title="アーティストとのチャットについて"
  >
        <div className="system-message-card__text">
          このチャットでは、アーティストとの連絡、確認事項、画像・ファイル送信、返信、リアクション、メンションが使えます。
        </div>
        <div className="system-message-card__text">
          アーティストから見るTacticartチャットには、許可されたタクティカートのスタッフが参加できます。必要なスタッフは@でメンションできます。
        </div>
        <div className="system-message-card__text">
          設定で既読を相手に伝えるかどうか、通知設定（自分用）などが行えます。
        </div>
  </ChatIntroGuidanceMessage>
);

export const AdminEventChatGuidanceMessage = () => (
  <ChatIntroGuidanceMessage
    messageId="admin-event-chat-guidance"
    title="イベントチャットについて"
  >
      <div className="system-message-card__text">
        このチャットは、イベントに参加するアーティストとタクティカートの関係スタッフが、出演に必要な連絡を行う場所です。
      </div>
      <div className="system-message-card__text">
        スケジュール、持ち物、当日の動き、共有事項を確認できます。@で参加者やスタッフを検索してメンションできます。
      </div>
      <div className="system-message-card__text">
        画像・ファイル送信、返信、リアクション、ノート、お知らせ、参加者確認が使えます。
      </div>
  </ChatIntroGuidanceMessage>
);

export const AdminGroupChatGuidanceMessage = () => (
  <ChatIntroGuidanceMessage
    messageId="admin-group-chat-guidance"
    title="グループチャットについて"
  >
    <div className="system-message-card__text">
      このチャットでは、グループに追加されたアーティストとの連絡、確認事項、画像・ファイル送信、返信、リアクション、メンションが使えます。
    </div>
  </ChatIntroGuidanceMessage>
);

export const ArtistGroupChatGuidanceMessage = () => (
  <ChatIntroGuidanceMessage
    messageId="artist-group-chat-guidance"
    title="グループチャットについて"
  >
    <div className="system-message-card__text">
      あなたはこのグループへ追加されました。グループに参加しているタクティカートスタッフや社員、アーティストとやりとりができます。画像・ファイル送信、返信、リアクション、メンションが使えます。
    </div>
  </ChatIntroGuidanceMessage>
);
